var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVotingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50364 6.71703C1.91543 6.53602 2.38903 6.75285 2.55637 7.19883L3.5156 9.53125H3.82376V3.1875C3.82376 2.70625 4.18743 2.3125 4.63177 2.3125C5.07638 2.3125 5.43978 2.70625 5.43978 3.1875V7.33691L5.84392 7.34375V1.875C5.84392 1.39375 6.2076 1 6.65194 1C7.09764 1 7.45995 1.39375 7.45995 1.875V7.33691L7.86327 7.34375V2.75C7.86327 2.26875 8.22694 1.875 8.67128 1.875C9.11589 1.875 9.47929 2.26875 9.47929 2.75V7.77441L9.88343 7.78125V4.5C9.88343 4.01875 10.2471 3.625 10.6914 3.625C11.1363 3.625 11.5 4.01875 11.5 4.5V10.4062C11.5 12.4789 10.4847 15 6.87889 15C5.76326 15 4.70724 14.8086 4.12646 14.4258C3.76226 14.1857 3.44894 13.8762 3.20442 13.515C3.0217 13.2454 2.87465 12.9533 2.76692 12.646L1.05902 7.85699C0.891954 7.41102 1.09184 6.89832 1.50364 6.71703Z",
    fill: "#81FEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotingActive);
export default __webpack_public_path__ + "static/media/voting_active.d51ae31b0118840b58373c9139dadad4.svg";
export { ForwardRef as ReactComponent };